import { useMutation, useQueryClient } from '@tanstack/react-query';
import { switchCompany } from '../api/auth.service';
import { useAuthStore } from '../store/authStore';
import { prefetchAvatar } from '@/features/files';

export const useSwitchCompany = () => {
  const queryClient = useQueryClient();
  const { fetchUser } = useAuthStore();

  return useMutation({
    mutationFn: (companyId: string | number) => switchCompany(companyId),
    onSuccess: async (data) => {
      useAuthStore.setState({ user: data.response_output.detail });
      await fetchUser();

      const user = useAuthStore.getState().user;
      if (user?.avatar_file_id) {
        await prefetchAvatar(queryClient, user.avatar_file_id);
      }
    },
  });
};
